import { useState } from "react";
import { LoginModal } from "./LoginModal";
import { CreateBlogModal } from "./CreateBlogModal";
import { useAuth } from "../hooks/useAuth";

export function MainMenu() {
    const [isCreateOpen, setIsCreateOpen] = useState(false);
    const [isLoginOpen, setIsLoginOpen] = useState(false);
    const { isAuthenticated, logout } = useAuth();

    // The dropdown is held open by focus, so it has to be dismissed explicitly
    // or it stays open behind whatever the item opened.
    const closeDropdown = () => {
        (document.activeElement as HTMLElement | null)?.blur();
    };

    const runAndClose = (action: () => void) => () => {
        closeDropdown();
        action();
    };

    return (
        <>
            <div className="dropdown dropdown-end">
                <div tabIndex={0} role="button" className="btn btn-ghost btn-circle">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="inline-block w-5 h-5 stroke-current"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path></svg>
                </div>
                <ul tabIndex={0} className="dropdown-content z-[1] menu p-2 shadow bg-base-200 rounded-box w-52">
                    {isAuthenticated && (
                        <>
                            <li><button onClick={runAndClose(() => setIsCreateOpen(true))}>New Post</button></li>
                            <li role="separator" className="my-1 h-px bg-base-content/10"></li>
                        </>
                    )}
                    {isAuthenticated ? (
                        <li><button onClick={runAndClose(logout)}>Logout</button></li>
                    ) : (
                        <li><button onClick={runAndClose(() => setIsLoginOpen(true))}>Login</button></li>
                    )}
                </ul>
            </div>

            <LoginModal isOpen={isLoginOpen} onClose={() => setIsLoginOpen(false)} />

            {isCreateOpen && (
                <CreateBlogModal isOpen={isCreateOpen} onClose={() => setIsCreateOpen(false)} />
            )}
        </>
    );
}
